/**
 * .tuMetrics {"tu1": 0.92, "tu2": 0.94, "tu3": 1, "notes": "Best-effort Web Push unsubscribe for this device", "tuVersion": "2.5"}
 * .help "Stops closed-tab push on this browser. Called from logout; the hook also runs when currentUser clears."
 */
export function pushSupported(): boolean {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}

export async function unsubscribeThisDevicePush(): Promise<void> {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) await sub.unsubscribe();
}
